import * as action from './bookingAction'
import { default as actionType } from './bookingActionType'
import { default as reducer } from './bookingReducer'

export const BOOKING = {
  action,
  actionType,
  reducer
}
